import { ContentType } from "@brookbush/database";
import type { Content } from "@brookbush/types";

import { clsx } from "clsx";
import format from "date-fns/format";
import Image from "next/image";

import { contentTypeMap } from "~/components/ContentCard";

const typeLabel = (type: ContentType): string =>
	type === ContentType.GLOSSARY ? "Glossary Term" : type.toLowerCase();

const ChatContentPreview = ({ content }: { content: Content }) => {
	const meta = contentTypeMap[content._type];
	const Icon = meta.icon;

	const credits = content.credits
		? `${content.credits} credit${content.credits > 1 ? "s" : ""}`
		: null;
	const duration =
		content._type === ContentType.VIDEO && content.duration
			? format(new Date(0).setSeconds(content.duration), "mm:ss")
			: null;

	return (
		<div className="flex w-64 gap-2.5">
			{content.thumbnail?.url ? (
				<div className="relative aspect-square h-14 shrink-0 overflow-hidden rounded-lg border">
					<Image
						src={content.thumbnail.url}
						alt={content.thumbnail.alt ?? content.title}
						fill
						className="object-cover"
					/>
				</div>
			) : (
				<div
					className={clsx(
						"flex aspect-square h-14 shrink-0 items-center justify-center rounded-lg border",
						meta.iconClassName,
					)}
				>
					<Icon className="size-5" />
				</div>
			)}

			<div className="flex min-w-0 flex-col gap-0.5">
				<div className="flex gap-2 font-medium text-xs capitalize">
					<span className={meta.className}>{typeLabel(content._type)}</span>
					{credits && <span>{credits}</span>}
					{duration && <span>{duration}</span>}
				</div>
				<h3 className="line-clamp-2 font-medium text-sm">{content.title}</h3>
			</div>
		</div>
	);
};

export default ChatContentPreview;
